import React, { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { getAuthSession, subscribeLogout } from '@/auth/logoutChannel';
import {
  hasLogoutStarted,
  setProfileIdentity,
  startLogout,
} from '@/auth/session';
import { STORED_OFFERS_SKIPPED_SESSION } from '@/auth/stored';
import { POST_LOGOUT_REDIRECT_URL } from '@/config/env';
import { useLogout } from '@/hooks/useLogout';
import { ROUTE_ROOT } from '@/router/routes';

export const LogoutSync: React.FC = () => {
  const { user, removeUser } = useAuth();
  const logout = useLogout();

  const currentSession = user ? getAuthSession(user) : undefined;
  const userId = currentSession?.userId;
  const sessionId = currentSession?.sessionId;

  useEffect(() => {
    if (!userId) {
      return;
    }

    return subscribeLogout(async (loggedOutSession) => {
      const isSameUser = loggedOutSession.userId === userId;

      if (!isSameUser || hasLogoutStarted()) {
        return;
      }

      const isSameSession =
        !!sessionId && loggedOutSession.sessionId === sessionId;

      if (!isSameSession) {
        await logout();
        return;
      }

      startLogout();
      sessionStorage.removeItem(STORED_OFFERS_SKIPPED_SESSION);
      setProfileIdentity(undefined);
      await removeUser();
      window.location.replace(POST_LOGOUT_REDIRECT_URL || ROUTE_ROOT);
    });
  }, [userId, sessionId, logout, removeUser]);

  return null;
};
